import { trackAnalyticsSafely } from "./AnalyticsTracker";
import {
    AppAdoptionFilterPayload,
    AppAdoptionInvitationsPayload,
    AppAdoptionSearchPayload,
    AppAdoptionSummaryPayload,
} from "./AppAdoptionEvents";

export class AppAdoptionAnalyticsHelper {
    static trackShown(payload: AppAdoptionSummaryPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.AppAdoption.Shown",
            payload,
        });
    }

    static trackRefreshed(payload: AppAdoptionSummaryPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.AppAdoption.Refreshed",
            payload,
        });
    }

    static trackLoadFailed() {
        trackAnalyticsSafely({
            eventType: "WebDashboard.AppAdoption.LoadFailed",
        });
    }

    static trackFilterChanged(payload: AppAdoptionFilterPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.AppAdoption.FilterChanged",
            payload,
        });
    }

    static trackSearched(payload: AppAdoptionSearchPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.AppAdoption.Searched",
            payload,
        });
    }

    static trackInvitationsSubmitted(payload: AppAdoptionInvitationsPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.AppAdoption.InvitationsSubmitted",
            payload,
        });
    }

    static trackInvitationsSucceeded(payload: AppAdoptionInvitationsPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.AppAdoption.InvitationsSucceeded",
            payload,
        });
    }

    static trackInvitationsFailed(payload: AppAdoptionInvitationsPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.AppAdoption.InvitationsFailed",
            payload,
        });
    }

    static trackDeviceDetailsOpened() {
        trackAnalyticsSafely({
            eventType: "WebDashboard.AppAdoption.DeviceDetailsOpened",
        });
    }
}
